import React, { useState, useEffect ,useRef} from "react";
import { AppBar, Toolbar, Box } from "@mui/material";
import NMH_LOGO_White_RGB from '../Assets/NMH_LOGO_White_RGB.png';
import {  useNavigate } from "react-router-dom";
import { KeyboardArrowDown } from '@mui/icons-material';
import {  Typography,ListItemText, Popper, Paper, MenuList, MenuItem, ClickAwayListener, Grow } from "@mui/material";
// import "./Homepage.css";
import axios from 'axios';

const   UserToolbar = () => {
    const navigate = useNavigate();
    const [userName, setUsername] = useState('');
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
    const getUserFromCookie = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, {
          withCredentials: true,
        });
        const { user, username } = res.data;
        if ( user === 'User') {
          setUsername(username);
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error('Error checking login:', err);
        navigate('/');
      } 
    };
    getUserFromCookie();
  }, [navigate]);

  const logoutAll = async () => {
  try {
      await axios.post(`${API_BASE_URL}/api/auth/logout`, {}, { withCredentials: true });
      localStorage.clear();
      sessionStorage.clear();

    //   const oktaIframe = document.createElement('iframe');
    //   oktaIframe.src = `https://nmhschool.okta.com/login/signout`;
    //   oktaIframe.style.display = 'none';
    //   document.body.appendChild(oktaIframe);
      const googleLogoutWindow = window.open(`https://accounts.google.com/logout`, '_blank');

      setTimeout(() => {
          if (googleLogoutWindow) googleLogoutWindow.close(); 
        //   document.body.removeChild(oktaIframe); 
          navigate('/login'); 
      }, 3000);
  } catch (error) {
      console.error('Logout failed:', error.message);
  }
};
 const HeaderOffset = () => (
  <Toolbar sx={{ minHeight: { xs: 200, sm: 80, lg: 70 } }} />
);
    return( <>
<AppBar position="fixed" className="app-bar"   sx={{ backgroundColor: '#002855', color: 'white',
                 height: {
                    xs: '200px', 
                    sm: '80px',  
                    lg: '70px',
                  },
                    '@media (max-width:400px)': {
                    height: '250px',
                  },
                  }}>
          <Toolbar>
            <img src={NMH_LOGO_White_RGB} className="toolbar-logo" alt="NMH Logo" />
         
             <Typography  sx={{ fontSize: '0.85rem',padding:1}}>{userName} </Typography>
            
            <Typography  className="title"   sx={{ fontSize: '1.1rem', fontWeight: 'bold', textAlign: 'center' }} >Opportunities Beyond Campus</Typography>


            <Box className="user-section">
              <MenuItem button  sx={{ padding:1}} onClick={() => navigate("/homepage")}>
                <ListItemText primary={<Typography sx={{ fontSize: '0.85rem', }}>Homepage</Typography>} />
              </MenuItem>
              <MenuItem button  sx={{ padding:1}} onClick={() => navigate("/Saved-Events")}>
                <ListItemText primary={<Typography sx={{ fontSize: '0.85rem', }}>Saved Events</Typography>} />
              </MenuItem>
               <MenuItem button  sx={{ padding:1}} onClick={() => navigate("/College-Counseling-Resources")}>
                <ListItemText primary={<Typography sx={{ fontSize: '0.85rem', }}>College Counseling Resources</Typography>} />
              </MenuItem>
               <MenuItem button onClick={logoutAll} sx={{ padding:2}}>
                <ListItemText primary={<Typography sx={{ fontSize: '0.85rem', fontWeight: 'bold'}}>Logout</Typography>} />
              </MenuItem>
              </Box>
          </Toolbar>
        </AppBar> 
        <HeaderOffset/>
        </> );
};

export default UserToolbar;